<template>
  <div class='fenceDetail'>
      <div id="container"></div>
      <div class='search' v-if="fenceTypeCode!=='schoolFence'">
         <input id='tipinput' v-model="searchKey" class="input" placeholder="请输入关键字">
      </div>
      <van-action-sheet v-model='isShow' :overlay='false'>
            <div class='addCon'>
              <p class="btn flex" v-if="fenceTypeCode!=='schoolFence'"><span @click="cancle">取消</span><b>添加围栏</b><span class='sure' @click='submit' >确定</span></p>
              <div class='formTxt flex'>
                  <span>名称</span>
                  <p><template v-if="this.fenceTypeCode=='schoolFence'">{{name}}</template>
                    <input type='text' v-model="name" placeholder="请输入" maxlength="20" v-else></p>
              </div>
              <div class='formTxt flex'>
                  <span>地址</span><p class="address">{{address}}</p>
              </div>
              <div class='formTxt flex'>
                  <span>范围</span>
                  <p><template v-if="this.fenceTypeCode=='schoolFence'">{{distance}}</template>
                    <input type='text' v-model="distance" placeholder="请输入" maxlength="4" @change="checkData" style='width:1rem;text-right:right' v-else>米
                  </p>
              </div>
              <div class='formTxt flex'>
                  <span>告警</span>
                  <p><template v-if="this.fenceTypeCode=='schoolFence'">{{needPush?typeName[pushTrigger]:'否'}}</template>
                     <template v-else>
                    <van-switch v-model="needPush" size='20px'  active-color="#2403df" style="margin-top:15px;"/></template>
                  </p>
              </div>
              <div class='flex radio' v-if="needPush&&fenceTypeCode!=='schoolFence'">
                  <van-radio-group v-model="pushTrigger"  direction="horizontal" icon-size='14px'>
                      <van-radio name="1">进围栏推送</van-radio>
                      <van-radio name="2">出围栏推送</van-radio>
                      <van-radio name="3">进出推送</van-radio>
                  </van-radio-group>
              </div>
            
            </div>
      </van-action-sheet>
  </div>
</template>
<script>

import {insertStudentFence,getStudentFenceInfo,updateStudentFence} from "@/api/api.equipment";
  export default {
    data() {
      return {
        mapObj:'',
        searchKey:'',//搜索内容
        details:'',
        name:'',
        id:this.$route.query.id,
        fenceTypeCode:this.$route.query.fenceTypeCode,
        address:'',
        longitude:'',//经度
        latitude:'',//纬度
        pushTrigger:'',//1进入推送；2离开推送；3进出推送
        needPush:false,
        distance:100,
        isShow:false,
        isPoint:null,
        typeName:['','进围栏推送','出围栏推送','进出推送']
      }
    },
    mounted(){
      this.getMaps();
   },
   created(){
     if(this.fenceTypeCode=='familyFence'){
       this.name='家庭坐标';
     }
     if(this.id){
       this.isShow=true;
       this.getList();
     }
     
    },
    methods: {
     
      //地图初始化
      getMaps(){
        let self=this;
        var map = new AMap.Map('container', {
            resizeEnable: true,
            zoom: 13
        });
         map.on('click',function(e){
                if(self.fenceTypeCode=='schoolFence') return
                // mapObj.remove([marker]);
                self.longitude=e.lnglat.lng;
                self.latitude=e.lnglat.lat;
                AMap.plugin('AMap.Geocoder', function() {
                  var geocoder = new AMap.Geocoder({
                           city: '全国'
                   });
                     geocoder.getAddress(e.lnglat, function(status, result) {
                       if (status === 'complete'&&result.regeocode) {
                            self.address = result.regeocode.formattedAddress;
                       }else{
                            self.$message.error('根据经纬度查询地址失败')
                       }
                     });
                 });
              
                self.getMark();
            })
        this.mapObj=map;
        this.getSearch();
       
      },
      getMark(){
        let self=this;
        this.isShow=true;
            this.mapObj.clearMap();
            var marker = new AMap.Marker({
                          icon:require('@/assets/img/location/map.png'),
                          offset: new AMap.Pixel(-12, -30),
                          position: [this.longitude, this.latitude]
                      });
                      // 构造矢量圆形
                      var circle = new AMap.Circle({
                          center:  new AMap.LngLat(this.longitude, this.latitude), // 圆心位置
                          radius:this.distance,  //半径
                          strokeColor: "#2403df",  //线颜色
                          strokeOpacity:  0.5,  //线透明度
                          strokeWeight: 1,  //线粗细度
                          fillColor: "#2403df",  //填充颜色
                          fillOpacity: 0.3 //填充透明度
                      });
                      circle.on('click',function(e){
                        if(self.fenceTypeCode=='schoolFence') return
                          self.longitude=e.lnglat.getLng();
                          self.latitude=e.lnglat.getLat();
                          AMap.plugin('AMap.Geocoder', function() {
                            var geocoder = new AMap.Geocoder({
                                    city: '全国'
                            });
                              geocoder.getAddress(e.lnglat, function(status, result) {
                                if (status === 'complete'&&result.regeocode) {
                                      self.address = result.regeocode.formattedAddress;
                                }else{
                                      self.$message.error('根据经纬度查询地址失败')
                                }
                              });
                          });
                        
                          self.getMark();
                      })
                      circle.setMap(this.mapObj);
                      this.mapObj.add([marker,circle]);
                      this.mapObj.setFitView([marker,circle]);
       },
       getSearch(){
         let self=this;
          AMap.plugin('AMap.Autocomplete', function(){
        // 实例化Autocomplete
         //输入提示
          var autoOptions = {
              input: "tipinput"
          };
          var auto = new AMap.Autocomplete(autoOptions);
          
          AMap.event.addListener(auto, "select", self.select);//注册监听，当选中某条记录时会触发
        
      })
   
      },
      select(e) {
    //     let self=this;
    //      var placeSearch = new AMap.PlaceSearch({
    //     map: this.mapObj
    // });  //构造地点查询类
    //     placeSearch.setCity(e.poi.adcode);
    //     placeSearch.search(e.poi.name);  //关键字查询查询
        // placeSearch.search(e.poi.name,function(status,result){
        //   if(status=='complete' || result.info=='OK')
        //   self.getMark();
        // })
         this.longitude=e.poi.location.lng;
         this.latitude=e.poi.location.lat;
         this.address=e.poi.address;
         if(this.fenceTypeCode=='otherFence'){
           this.name=e.poi.name;
         }
         
         this.getMark();
         this.isShow=true;
       },
       getList(){
         getStudentFenceInfo({
              fenceId:this.id
           }).then((data) => {
            if (data && data.result) {
              this.details=data.result;
              this.latitude=data.result.fenceRoundPoint.centerLatitude;
              this.longitude=data.result.fenceRoundPoint.centerLongitude;
              this.distance=data.result.fenceRoundPoint.radius;
              this.needPush=data.result.needPush==1?true:false;
              this.name=data.result.fenceName;
              this.pushTrigger=this.needPush?data.result.pushTrigger.toString():'';
              this.address=data.result.fenceAddress;
              this.getMark();
             
            }
         })
       },
       checkData(){
         let str=this.pubMethod.checkInt(this.distance);
         if(!str){
           this.$toast('请输入整数');
           this.distance=100;
           return false
         }else if(this.distance<100){
           this.distance=100;
         }
         this.getMark();
       },
       submit(){
         if(this.name==''){
           this.$toast('请设置名称');
           return false;
         }
         let params={
                  schoolId:this.loginUser.schoolId,
                  studentId:this.loginUser.studentId,
                  pushTrigger:this.pushTrigger,
                  needPush:this.needPush?1:0,
                  fenceName:this.name,
                  fenceTypeCode:this.fenceTypeCode,
                  fenceId:this.id,
                  fenceAddress:this.address,
                  circleFence:{
                    circlePoint:{
                      coordinateSystem:2,
                      longitude:this.longitude,
                      latitude:this.latitude
                    },
                    radius:this.distance
                  }
              };
         if(this.id){
           updateStudentFence(params).then((data) => {
                if (data && data.result) {
                  this.$router.go(-1)
                }else{
                  this.$toast(data.message);
                }
            })
         }else{
           insertStudentFence(params).then((data) => {
                if (data && data.result) {
                  this.$router.go(-1)
                }else{
                  this.$toast(data.message);
                }
            })
         }
         
       },
       cancle(){
         this.isShow=false;
       }
    },
   
  }
</script>
<style lang="scss" >
.fenceDetail{
  height: 100%;
  .amap-icon img{
    height: 30px;
  }
  #container{
    height:100%;
    width:100%;
    z-index: 1;
 }
 .flex{
     display: flex;
     justify-content: space-between;
 }
 .search{
   position:absolute;
   top: 50px;
   left:0px;
   z-index:3;
   width: 100%;
   .input{
     width:80%;
     margin:.2rem auto;
     line-height: 34px;
     text-indent:.2rem;
     border-radius: 8px;
     box-shadow: 0px 4px 12px rgba(0,0,0,.1);
     border:none;
     display: block;
     font-size: 14px;
     background:#fff;
   }
 }
 .addCon{
   .formTxt{
     line-height:.56rem;
     font-size: .14rem;
     p{
       width: 74%;
       text-align: right;
       &.address{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;}
     }
     input{
       border:none;
       line-height: 30px;
       height: 30px;
       text-align: right;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis;
       width: 100%;
     }
   }
 }
}

</style>